<template>
  <div class="row ml-0">
    <div class="col-11">
      <div class="row align-items-center">
        <div class="col light-background rounded-left">
          <select
            class="right-chevron pl-2"
            v-model="filterProps.dateRangeType"
          >
            <option value="creation">{{
              $t('reservations.bookings.list.search.creation-date-range')
            }}</option>
            <option value="departure">{{
              $t('reservations.bookings.list.search.departure-date-range')
            }}</option>
          </select>
        </div>
        <div class="col light-background rounded-right">
          <core-date-range-calendar
            :key="resetFormKey"
            :start.sync="filterProps.createdFrom"
            :end.sync="filterProps.createdUntil"
            :locale="'en-GB'"
            :placement="'top'"
          ></core-date-range-calendar>
        </div>
        <div class="input-group col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-id"
            v-model="filterProps.id"
            type="text"
            :placeholder="
              $t('reservations.bookings.list.search.reservation-id-placeholder')
            "
          />
        </div>
        <div class="col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-person-id"
            v-model="filterProps.personId"
            type="text"
            :placeholder="
              $t('reservations.bookings.list.search.person-id-placeholder')
            "
          />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-person-email"
            v-model="filterProps.personEmail"
            type="text"
            :placeholder="$t('reservations.bookings.list.search.person-email')"
          />
        </div>
        <div class="col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-person-lastname"
            v-model="filterProps.personLastName"
            type="text"
            :placeholder="
              $t('reservations.bookings.list.search.person-lastname')
            "
          />
        </div>
        <div class="col">
          <core-basic-drop-down
            :key="filterProps.paymentStatusId"
            class="payment-status-selection"
            forceFirstOption
            :items="paymentStatuses"
            :selection.sync="filterProps.paymentStatusId"
            :noneLabel="$t('reservations.bookings.list.search.payment-status')"
          ></core-basic-drop-down>
        </div>
        <div class="col ">
          <core-basic-drop-down
            v-if="assignmentOptions.length"
            :items="assignmentOptions"
            :labelAttribute="'initials'"
            :noneLabel="$t('reservations.bookings.list.search.user')"
            :forceFirstOption="true"
            :selection.sync="filterProps.userId"
            :key="filterProps.userId"
            class="assignment-option-selection"
          ></core-basic-drop-down>
        </div>
        <div class="col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-reference"
            v-model="filterProps.reference"
            type="text"
            :placeholder="$t('reservations.bookings.list.search.reference')"
          />
        </div>

        <div class="col light-background rounded-left" v-if="!reservationStatusCode">
          <select
            class="right-chevron pl-2"
            v-model="filterProps.reservationStatusId"
          >
            <option :value="0"> {{ $t('reservations.bookings.list.search.all-statuses') }}</option>
            <option v-bind:key="status.id" :value="status.id" v-for="status in reservationStatusesOrigin" v-if="['TODO', 'IN-PROGRESS', 'PARTIALLY-TODO', 'DONE', 'QUOTE-REQUEST'].includes(status.code)">
              {{ statusNameField(status) }}
            </option>
          </select>
        </div>
        <div class="col light-background rounded-left">
          <select
            class="right-chevron pl-2"
            v-model="filterProps.countryCode"
          >
            <option :value="0"> {{ $t('reservations.bookings.list.search.all-countries') }}</option>
            <option v-bind:key="c.id" :value="c.code" v-for="c in countries">
              {{ getName(c) }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col"><input
            class="form-control search-input filter-border-bottom"
            readonly
            type="text"
            :placeholder="$t('reservations.bookings.list.search.departure-date')"
          /></div>
        <div class="col light-background rounded-right">
          <core-date-range-calendar
            :key="resetFormKey"
            :start.sync="filterProps.departureDateFrom"
            :end.sync="filterProps.departureDateUntil"
            :locale="'en-GB'"
            :placement="'top'"
          ></core-date-range-calendar>
        </div>
        <div class="col"><input
          class="form-control search-input filter-border-bottom"
          readonly
          type="text"
          :placeholder="$t('reservations.bookings.list.search.arrival-date')"
        /></div>
        <div class="col light-background rounded-right">
          <core-date-range-calendar
            :key="resetFormKey"
            :start.sync="filterProps.arrivalDateFrom"
            :end.sync="filterProps.arrivalDateUntil"
            :locale="'en-GB'"
            :placement="'top'"
          ></core-date-range-calendar>
        </div>
        <div class="col"><input
          class="form-control search-input filter-border-bottom"
          readonly
          type="text"
          :placeholder="$t('reservations.bookings.list.search.booking-date')"
        /></div>
        <div class="col light-background rounded-right">
          <core-date-range-calendar
            :key="resetFormKey"
            :start.sync="filterProps.bookingDateFrom"
            :end.sync="filterProps.bookingDateUntil"
            :locale="'en-GB'"
            :placement="'top'"
          ></core-date-range-calendar>
        </div>
      </div>
      <div class="row">
        <div class="col-2"><input
          class="form-control search-input filter-border-bottom"
          name="reservation-person-lastname"
          v-model="filterProps.serviceName"
          type="text"
          :placeholder="$t('reservations.bookings.list.search.service-name')"
        /></div>
        <div class="col-2">
          <select
            class="right-chevron pl-2 lang-select"
            v-model="filterProps.languageId"
          >
            <option :value="0"> {{ $t('reservations.bookings.list.search.all-languages') }}</option>
            <option v-bind:key="c.id" :value="c.id" v-for="c in languages">
              {{ getName(c) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-1 text-right">
      <button @click="resetForm" class="btn btn-sm btn-primary">
        {{ $t('reservations.bookings.list.search.reset-form') }}
      </button>
      <button @click="getExport" class="btn btn-sm btn-primary">
        {{ $t('reports.supplier-reports-search.export')}}
      </button>
    </div>
  </div>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
import PaymentStatus from '@/services/hatsApi/PaymentStatus'
import ReservationStatus from '@/services/hatsApi/ReservationStatus'
import User from '@/services/hatsApi/User'
import moment from 'moment'
import Geo from '@/services/hatsApi/Geo'
import Language from '@/services/hatsApi/Language'

export default {
  data () {
    return {
      assignmentOptions: [],
      resetFormKey: false,
      paymentStatuses: [],
      countries: [],
      languages: [],
      reservationStatuses: {},
      reservationStatusesOrigin: [],
      filterProps: {
        id: '',
        personId: '',
        personEmail: '',
        personLastName: '',
        paymentStatusId: null,
        countryCode: 0,
        languageId: 0,
        /* arrivalDateFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        arrivalDateUntil: moment()
          .add(1, 'year')
          .format('YYYY-MM-DD'),
        departureDateFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        departureDateUntil: moment()
          .add(1, 'year')
          .format('YYYY-MM-DD'), */
        arrivalDateFrom: '',
        arrivalDateUntil: '',
        departureDateFrom: '',
        departureDateUntil: '',
        bookingDateFrom: '',
        bookingDateUntil: '',
        userId: null,
        reference: '',
        serviceName: '',
        reservationStatusId: 0,
        dateRangeType: 'creation',
        createdFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        createdUntil: moment().format('YYYY-MM-DD')
      }
    }
  },
  watch: {
    filterProps: {
      handler () {
        this.debouncedSearch()
      },
      deep: true,
      immediate: false
    }
  },
  created: function () {
    this.getPaymentStatuses()
    this.getReservationStatuses()
    this.getAssignmentOptions()
    Geo.getCountries().then((response) => {
      this.countries = response.data.data
      // this.countries.unshift({'name_NL': 'Country', 'code': ''})
    })
    Language.getLanguages().then((response) => {
      this.languages = response.data.data
    })
    this.debouncedSearch = this.$_.debounce(this.prepareAndEmitFilters, 500)
  },
  mounted: function () {
    this.debouncedSearch()
  },
  props: ['reservationStatusCode'],
  methods: {
    getName (item) {
      return item[('name_' + this.$i18n.locale.toUpperCase())]
    },
    frontEndDateFormat (date, format) {
      if (!date) {
        return ''
      }
      if (format) {
        return this.$moment(date, 'YYYY-MM-DD').format(format)
      } else {
        return this.$moment(date, 'YYYY-MM-DD')
      }
    },
    statusNameField (status) {
      return status['name_' + this.$i18n.locale.toUpperCase()]
    },
    async getAssignmentOptions () {
      const { data } = await User.getUsers()
      this.assignmentOptions = data.data
      this.assignmentOptions.forEach(item => {
        item.initials = `${item.firstName
          .substring(0, 1)
          .toUpperCase()}${item.lastName.substring(0, 1).toUpperCase()}`
      })
    },
    resetForm () {
      this.filterProps = {
        id: '',
        personId: '',
        personEmail: '',
        personLastName: '',
        paymentStatusId: null,
        userId: null,
        reference: '',
        reservationStatusId: 0,
        dateRangeType: 'creation',
        createdFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        createdUntil: moment().format('YYYY-MM-DD'),
        countryCode: '',
        arrivalDateFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        arrivalDateUntil: moment()
          .add(1, 'year')
          .format('YYYY-MM-DD'),
        departureDateFrom: moment()
          .subtract(2, 'years')
          .format('YYYY-MM-DD'),
        departureDateUntil: moment()
          .add(1, 'year')
          .format('YYYY-MM-DD'),
        bookingDateFrom: '',
        bookingDateUntil: ''
      }
      this.resetFormKey = !this.resetFormKey
    },
    prepareFilters () {
      if (this.filterProps.countryCode && this.filterProps.countryCode.code) {
        this.filterProps.countryCode = this.filterProps.countryCode.code
      }
      let filters = []
      const copiedFilters = { ...this.filterProps }
      if (copiedFilters.dateRangeType === 'departure') {
        copiedFilters.dateFrom = copiedFilters.createdFrom
        copiedFilters.dateUntil = copiedFilters.createdUntil
        delete copiedFilters.createdFrom
        delete copiedFilters.createdUntil
      }
      Object.keys(copiedFilters).forEach(filterProp => {
        if (filterProp !== 'dateRangeType' && copiedFilters[filterProp]) {
          let f = {
            property: `${filterProp}`,
            value: `${copiedFilters[filterProp]}`
          }
          filters.push(f)
        }
      })
      return filters
    },
    prepareAndEmitFilters () {
      this.$emit('filtersUpdated', this.prepareFilters())
    },
    async getPaymentStatuses () {
      try {
        let paymentStatusResponse = await PaymentStatus.getAll()
        if (paymentStatusResponse.data.success) {
          this.paymentStatuses = paymentStatusResponse.data.data
        }
      } catch (error) {
        console.error('getPaymentStatuses', error)
      }
    },
    async getReservationStatuses () {
      try {
        let reservationStatusResponse = await ReservationStatus.getAll()
        if (reservationStatusResponse.data.success) {
          reservationStatusResponse.data.data.forEach((elm) => {
            if (this.reservationStatusCode && this.reservationStatusCode === elm.code) {
              // setTimeout(() => {
              this.filterProps.reservationStatusId = elm.id
              // }, 100)
            }
            this.reservationStatuses[elm.code] = elm
          })
          this.reservationStatusesOrigin = reservationStatusResponse.data.data
        }
      } catch (error) {
        console.error('getReservationStatuses', error)
      }
    },
    async getExport () {
      try {
        const downloadFileResponse = await Reservation.reservationsExport(this.prepareFilters(), this.$root.$i18n.locale)
        if (downloadFileResponse.data) {
          const file = new Blob(
            [downloadFileResponse.data],
            { type: downloadFileResponse.data.type }
          )
          const fileURL = URL.createObjectURL(file)
          // Workaround to force download
          // We create <a> element and attach href/download than force click it
          var element = document.createElement('a')
          element.href = fileURL
          element.download = 'reservations.csv'
          document.body.appendChild(element)
          element.click()
          element.remove()
        }
      } catch (e) {
        console.log('Error: ', e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
select.input-group {
  border-bottom: 1px solid #dddddd;
  border-radius: 0;
  padding: 6px;
}
.lang-select{
  position: relative;
  top: 9px;
}

.light-background {
  .right-chevron {
    line-height: 35px;
  }
  background-color: #f7fafc;
}

/deep/ .vc-shadow {
  border: none;
  background-color: #f7fafc;
  box-shadow: none;
  color: #008cdd;
  font-family: 'Open Sans Semibold';
  font-size: 14px;
}

.payment-status-selection,
.assignment-option-selection {
  font-family: 'Open Sans Italic';
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  line-height: 26px;
  border-bottom: 1px solid #dddddd;
  border-radius: 0;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/Reservation.vue